import { ActionTree } from 'vuex';
import { CalendarState } from './types';
import { RootState } from '@/vuex/types';
import { esensDefaultFilters, zoukDefaultFilters } from './dafaults';
import EventBus from '@/communication/EventBus';

export const actions: ActionTree<CalendarState, RootState> = {
    setWidths({ commit }, widths): void {
        commit('storeWeekdaysContainerWidth', widths.weekdaysContainerWidth);
        commit('storeWeekdayContainerWidth', widths.weekdayContainerWidth);
        commit('storeLocationWidth', widths.locationWidth);
        commit('storeBoxWidth', widths.boxWidth);
        commit('storeCellHeight', widths.cellHeight);
        commit('storeBoxType', widths.boxType);
    },
    setHours({ commit }, hours): void {
        commit('storeAllHours', hours.allHours);
        commit('storeHoursWithEvents', hours.hoursWithEvents);
    },
    setEvents({ commit }, events): void {
        commit('storeEvents', events);
    },
    setFilteredEvents({ commit }, filteredEvents): void {
        commit('storeFilteredEvents', filteredEvents);
    },
    setCalendarFilter({ commit }, calendarFilter): void {
        commit('storeCalendarFilter', calendarFilter);
    },
    cleanCalendarFilters({ commit }): void {
        commit('storeCalendarFilters', {});
    },
    setHiddenFilters({ commit }, hiddenFilters): void {
        commit('storeHiddenFilters', hiddenFilters);
    },
    setIsMobile({ commit }, isMobile): void {
        commit('storeIsMobile', isMobile);
    },
    closeAllSingleActivityPopups({ commit }): void {
        commit('storeOpenedSingleActivityPopups', []);
    },
    openSingleActivityPopup({ commit }, eventId): void {
        commit('storeOpenedSingleActivityPopup', eventId);
    },
    changeVariant({ commit }, variantName): void {
        let calendarFilters = {};
        switch (variantName) {
            case 'zoukwroclove':
                calendarFilters = zoukDefaultFilters();
                break;
            case 'esens':
            default:
                calendarFilters = esensDefaultFilters();
                break;
        }
        commit('storeCalendarFilters', calendarFilters);
        EventBus.$emit('filtersChanged');
    },
};
